<!-- eslint-disable tailwindcss/no-custom-classname -->
<!-- eslint-disable vue/component-name-in-template-casing -->
<template>
  <ContentSection
    class="transition-opacity duration-1000 ease-out"
    :class="isReady ? `opacity-100` : `opacity-0`"
  >
    <Container tag="div">
      <h2 class="mb-9 font-semibold typo-h3">
        {{ data.heading }}
      </h2>
      <AnimatedContainer
        v-if="!hasSlider"
        class="grid gap-8 xs:auto-rows-[468px]"
        :class="{
          '2xl:grid-cols-3': mosaicSm,
          'lg:auto-rows-[468px]': mosaicSm || mosaicMd,
          'lg:grid-cols-12': mosaicMd || mosaicLg,
          '2xl:auto-rows-[468px] lg:auto-rows-[156px]': mosaicLg,
        }"
      >
        <TeaserFlexibleItem
          v-for="(item, index) in teaser_items"
          :key="item.id"
          :index="index"
          :item="item"
          :has-slider="hasSlider"
          :mosaic-md="mosaicMd"
          :mosaic-lg="mosaicLg"
          class="zoom-in"
        />
      </AnimatedContainer>
      <swiper-container
        v-if="hasSlider"
        ref="sliderRef"
        class="customs-swiper-style h-[468px]"
      >
        <swiper-slide
          v-for="(item, index) in teaser_items"
          :key="item.id"
        >
          <TeaserFlexibleItem
            :index="index"
            :item="item"
            :mosaic-md="mosaicMd"
            :mosaic-lg="mosaicLg"
            class="h-full"
          />
        </swiper-slide>
      </swiper-container>
      <div v-if="hasSlider && swiper" class="flex justify-between gap-2 pt-2">
        <AppButton
          type="button"
          :disabled="slideFirst"
          variant="secondary"
          @click="swiper.prev()"
        >
          <template #icon>
            <IconArrowLeft class="size-8" />
          </template>
        </AppButton>
        <AppButton
          type="button"
          :disabled="slideLast"
          variant="secondary"
          @click="swiper.next()"
        >
          <template #icon>
            <IconArrowRight class="size-8" />
          </template>
        </AppButton>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { MainComponentsTeaserFlexibleFragment } from '#gql'
import 'swiper/css'

const props = defineProps<{
  data: Enforce<MainComponentsTeaserFlexibleFragment>
}>()

const mosaicSm = computed(() => props.data.mosaic_size.value === 'sm')
const mosaicMd = computed(() => props.data.mosaic_size.value === 'md')
const mosaicLg = computed(() => props.data.mosaic_size.value === 'lg')

const teaser_items = computed(() => {
  if (mosaicMd.value) {
    return props.data.teaser_items.slice(0, 3)
  }
  if (mosaicLg.value) {
    return props.data.teaser_items.slice(0, 4)
  }
  return props.data.teaser_items
})

const hasSlider = computed(() => mosaicSm.value && teaser_items.value.length > 3)

const isReady = ref(false)
const sliderRef = ref(null)
const slideFirst = ref(true)
const slideLast = ref(false)

const swiper = hasSlider.value
  ? useSwiper(sliderRef, {
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      1280: {
        spaceBetween: 32,
        slidesPerView: 2,
      },
      1536: {
        spaceBetween: 32,
        slidesPerView: 3,
      },
    },
  })
  : null

onMounted(async () => {
  await nextTick()
  if (hasSlider.value && swiper) {
    const swiperInstance = swiper.instance.value

    if (swiperInstance) {
      swiperInstance.on('reachBeginning', () => {
        slideFirst.value = true
      })
      swiperInstance.on('fromEdge', () => {
        slideFirst.value = false
        slideLast.value = false
      })
      swiperInstance.on('reachEnd', () => {
        slideLast.value = true
      })
    }
  }
  isReady.value = true
})
</script>
